/* Halloween drop 02 countdown: Seance, the talking board.
   html[data-state] is soon / live / closed; ?now=<ISO> fakes the clock for review.
   A visitor picks a letter by holding the planchette's window on it for half a
   second. Spelling CULT, RACE or MD sets off the jump scare. */
(function () {
  "use strict";
  // the theme passes the times in on the section; the defaults are drop 02's 13 hours
  var sec = document.getElementById("seance");
  var OPEN = Date.parse((sec && sec.getAttribute("data-open")) || "2026-10-23T12:00:00-04:00");
  var CLOSE = Date.parse((sec && sec.getAttribute("data-close")) || "2026-10-24T01:00:00-04:00");
  var DWELL = 500;                       // ms on a letter before it counts
  var WORDS = { CULT: "You're in the cult now", RACE: "You can't outrun it", MD: "MD is watching" };
  var RM = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  var root = document.documentElement;

  var baseOffset = 0, offset = 0;
  var q = new URLSearchParams(location.search);
  if (q.get("now")) { var t0 = Date.parse(q.get("now")); if (!isNaN(t0)) baseOffset = offset = t0 - Date.now(); }
  function now() { return Date.now() + offset; }

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function el(tag, cls, parent) { var e = document.createElement(tag); if (cls) e.className = cls; if (parent) parent.appendChild(e); return e; }
  function restart(node, cls) { node.classList.remove(cls); void node.getBoundingClientRect(); node.classList.add(cls); }

  var state = null;

  /* ================= the board ================= */
  var board = document.getElementById("board"), pl = document.getElementById("pl"), says = document.getElementById("says");
  var P = {}, AR = 1.42;
  function add(key, txt, x, y, r, cls) {
    var e = el("span", "gl" + (cls ? " " + cls : ""), board);
    e.textContent = txt; e.style.left = x + "%"; e.style.top = y + "%";
    if (r) e.style.setProperty("--r", r.toFixed(1) + "deg");
    e.setAttribute("aria-hidden", "true");
    if (key) P[key] = [x, y, e];
  }
  // two arcs of letters, the numbers, YES, NO and GOOD BYE: the layout of a talking board
  var A = "ABCDEFGHIJKLM", N = "NOPQRSTUVWXYZ", i, x, u;
  for (i = 0; i < 13; i++) {
    x = 10 + i / 12 * 80; u = (x - 50) / 40;
    add(A[i], A[i], x, 34 + 11 * u * u, Math.atan(22 * (x - 50) / 1600 / AR) * 180 / Math.PI);
  }
  for (i = 0; i < 13; i++) {
    x = 13 + i / 12 * 74; u = (x - 50) / 37;
    add(N[i], N[i], x, 55 + 10 * u * u, Math.atan(20 * (x - 50) / 1369 / AR) * 180 / Math.PI);
  }
  "1234567890".split("").forEach(function (n, j) { add(n, n, 20 + j * 60 / 9, 77, 0, "gl--n"); });
  add("YES", "Yes", 13, 13, 0, "gl--word");
  add("NO", "No", 87, 13, 0, "gl--word");
  add(null, "Cult Racing", 50, 12, 0, "gl--wm");
  add("BYE", "Good Bye", 50, 91, 0, "gl--word");
  P.REST = [50, 45];

  var token = 0, cur = "REST", rot = 0, dragging = false, resumeT = null, grab = null;
  var cand = null, dwellT = null;        // the letter under the window, and its half-second timer
  var typed = "", typedAt = 0;           // what the visitor has spelled, kept across grabs for 15 s
  var scaring = false;

  function W() { return board.clientWidth; } function H() { return board.clientHeight; }
  // place the planchette so its window is over (px, py)
  function setPl(px, py, r) {
    var w = W() * .21, h = w * 1.2;
    pl.style.transform = "translate(" + (px - w * .5).toFixed(1) + "px," + (py - h * 62 / 120).toFixed(1) + "px) rotate(" + r.toFixed(1) + "deg)";
    pl._x = px; pl._y = py;
  }
  function jump(key) { pl.style.transition = "none"; cur = key; setPl(P[key][0] / 100 * W(), P[key][1] / 100 * H(), rot); void pl.getBoundingClientRect(); pl.style.transition = ""; }
  function go(key, fast) {
    var p = P[key], tx = p[0] / 100 * W(), ty = p[1] / 100 * H();
    pl.classList.toggle("fast", !!fast);
    if (RM) { jump(key); return wait(fast ? 120 : 400); }
    if (key === cur && key !== "REST") { // the same letter twice: lift off and come back
      setPl(tx + W() * .05, ty - H() * .1, rot);
      return wait(fast ? 260 : 520).then(function () { setPl(tx, ty, rot); return wait(fast ? 300 : 620); });
    }
    rot = rnd(-9, 9); cur = key; setPl(tx, ty, rot);
    return wait(fast ? 470 : 1040);
  }
  function light(key, keep) {
    var e = P[key] && P[key][2]; if (!e) return;
    e.classList.add("lit"); if (!keep) setTimeout(function () { e.classList.remove("lit"); }, 1500);
  }
  function sayClear() { says.textContent = ""; }
  function sayAdd(ch) { if (ch === " ") { says.appendChild(document.createTextNode(" ")); return; } el("i", "", says).textContent = ch; }
  function sayShow(text) { // the visitor's word so far; only the newest letter burns in
    says.textContent = text.slice(0, -1);
    if (text) el("i", "", says).textContent = text.slice(-1);
  }
  function unit(n, one, many) { return n + " " + (n === 1 ? one : many); }
  function message() {
    var p = parts(OPEN - now());
    if (p.d > 0) return unit(p.d, "DAY", "DAYS") + (p.h ? " " + unit(p.h, "HR", "HRS") : "");
    if (p.h > 0) return unit(p.h, "HR", "HRS") + (p.m ? " " + unit(p.m, "MIN", "MIN") : "");
    return unit(Math.max(1, p.m), "MIN", "MIN");
  }
  async function spell(tok, text, fast) {
    sayClear();
    for (var k = 0; k < text.length; k++) {
      var ch = text[k];
      if (tok !== token) return false;
      if (!P[ch]) { sayAdd(ch); continue; }
      await go(ch, fast);
      if (tok !== token) return false;
      light(ch); sayAdd(ch);
      await wait(fast ? 150 : 380);
    }
    return true;
  }
  async function loop(tok) {
    while (tok === token && state === "soon") {
      if (!(await spell(tok, message()))) return;
      await go("REST");
      await wait(2800);
    }
  }

  /* ---- the visitor's turn: grab it, hold the window on a letter for half a second to pick it ---- */
  // the letter under the window. One already counting keeps a slightly wider circle,
  // so a shaky finger does not restart the half second.
  function under(px, py, bw, bh) {
    var best = null, bd = 1e9;
    for (var k in P) {
      if (k === "REST") continue;
      var dx = (P[k][0] / 100) * bw - px, dy = (P[k][1] / 100) * bh - py, d = dx * dx + dy * dy;
      if (d < bd) { bd = d; best = k; }
    }
    var lim = bw * (best === cand ? .045 : .032);
    return bd < lim * lim ? best : null;
  }
  function dropCand() {
    clearTimeout(dwellT); dwellT = null;
    pl.classList.remove("dwell");
    if (cand && P[cand]) P[cand][2].classList.remove("hover");
    cand = null;
  }
  function track(k) {
    if (k === cand) return;              // still on the same letter: let the count run
    dropCand();
    if (!k) return;
    cand = k;
    P[k][2].classList.add("hover");
    restart(pl, "dwell");
    dwellT = setTimeout(function () { if (dragging && cand === k) pick(k); }, DWELL);
  }
  function pick(k) {                     // cand stays k, so the same letter needs a move off and back
    var e = P[k][2];
    dwellT = null;
    e.classList.remove("hover"); pl.classList.remove("dwell");
    light(k); if (!RM) restart(e, "pick");
    cur = k;
    if (Date.now() - typedAt > 15000) typed = "";
    typedAt = Date.now();
    if (k === "YES" || k === "NO" || k === "BYE") {   // a word on the board ends whatever was being spelled
      typed = "";
      says.textContent = k === "BYE" ? "GOOD BYE" : k;
      return;
    }
    typed = (typed + k).slice(-12);
    sayShow(typed);
    for (var w in WORDS) if (typed.slice(-w.length) === w) { typed = ""; scare(w); return; }
  }

  pl.addEventListener("pointerdown", function (e) {
    if (state !== "soon" || scaring) return;
    e.preventDefault(); unlock();
    dragging = true; token++; clearTimeout(resumeT);
    try { pl.setPointerCapture(e.pointerId); } catch (_) {}
    pl.classList.add("drag");
    var b = board.getBoundingClientRect();
    grab = { dx: (pl._x || 0) - (e.clientX - b.left), dy: (pl._y || 0) - (e.clientY - b.top) };
    if (typed && Date.now() - typedAt < 15000) sayShow(typed); else { typed = ""; sayClear(); }
    track(under(pl._x || 0, pl._y || 0, b.width, b.height));
  });
  pl.addEventListener("pointermove", function (e) {
    if (!dragging) return;
    var b = board.getBoundingClientRect();
    var px = clamp(e.clientX - b.left + grab.dx, 0, b.width), py = clamp(e.clientY - b.top + grab.dy, 0, b.height);
    setPl(px, py, rot);
    track(under(px, py, b.width, b.height));
  });
  function end() {
    unlock();
    if (!dragging) return;
    dragging = false; pl.classList.remove("drag"); dropCand();
    resumeT = setTimeout(function () { if (state === "soon" && !scaring && !dragging) loop(++token); }, 4000);
  }
  pl.addEventListener("pointerup", end);
  pl.addEventListener("pointercancel", end);
  window.addEventListener("resize", function () { if (!dragging) jump(cur); });

  /* ================= the jump scare ================= */
  var scareEl = document.getElementById("scare"), scareTxt = document.getElementById("scareTxt");
  var scareAt = 0, closeT = null, ac = null, unlocked = false;

  // browsers only allow sound after a gesture, so grabbing the planchette unlocks it
  function unlock() {
    try {
      if (!ac) { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return; ac = new AC(); }
      if (ac.state === "suspended") ac.resume();
      if (!unlocked) { // one silent sample, which older iPhones need before they play anything
        var s = ac.createBufferSource(); s.buffer = ac.createBuffer(1, 1, 22050); s.connect(ac.destination); s.start(0);
        unlocked = true;
      }
    } catch (_) {}
  }
  // a noise burst, a detuned screech driven into distortion, and a low hit, all synthesised
  function scream() {
    if (!ac) return;
    try {
      var t = ac.currentTime + .01, j;
      var comp = ac.createDynamicsCompressor(); comp.connect(ac.destination);
      var master = ac.createGain(); master.gain.value = .9; master.connect(comp);

      var len = Math.floor(ac.sampleRate * 1.6), buf = ac.createBuffer(1, len, ac.sampleRate), d = buf.getChannelData(0);
      for (j = 0; j < len; j++) d[j] = Math.random() * 2 - 1;
      var noise = ac.createBufferSource(); noise.buffer = buf;
      var bp = ac.createBiquadFilter(); bp.type = "bandpass"; bp.Q.value = .9;
      bp.frequency.setValueAtTime(3200, t); bp.frequency.exponentialRampToValueAtTime(700, t + 1.3);
      var ng = ac.createGain(); ng.gain.setValueAtTime(.0001, t); ng.gain.exponentialRampToValueAtTime(1, t + .012); ng.gain.exponentialRampToValueAtTime(.001, t + 1.5);
      noise.connect(bp); bp.connect(ng); ng.connect(master); noise.start(t); noise.stop(t + 1.6);

      var shaper = ac.createWaveShaper(), curve = new Float32Array(1024);
      for (j = 0; j < 1024; j++) curve[j] = Math.tanh((j / 512 - 1) * 6);
      shaper.curve = curve;
      var sg = ac.createGain(); sg.gain.setValueAtTime(.0001, t); sg.gain.exponentialRampToValueAtTime(.45, t + .02); sg.gain.exponentialRampToValueAtTime(.001, t + 1.4);
      shaper.connect(sg); sg.connect(master);
      var lfo = ac.createOscillator(), lg = ac.createGain(); lfo.frequency.value = 28; lg.gain.value = 45; lfo.connect(lg); lfo.start(t); lfo.stop(t + 1.5);
      [520, 556, 611, 1040].forEach(function (f) {
        var o = ac.createOscillator(), g = ac.createGain(); o.type = "sawtooth";
        o.frequency.setValueAtTime(f, t); o.frequency.exponentialRampToValueAtTime(f * .82, t + 1.3);
        lg.connect(o.frequency); g.gain.value = .25; o.connect(g); g.connect(shaper); o.start(t); o.stop(t + 1.5);
      });

      var hit = ac.createOscillator(), hg = ac.createGain(); hit.type = "sine";
      hit.frequency.setValueAtTime(70, t); hit.frequency.exponentialRampToValueAtTime(28, t + .6);
      hg.gain.setValueAtTime(1, t); hg.gain.exponentialRampToValueAtTime(.001, t + .8);
      hit.connect(hg); hg.connect(master); hit.start(t); hit.stop(t + .9);
    } catch (_) {}
  }
  function scare(word) {
    if (scaring) return;
    scaring = true; scareAt = Date.now();
    dragging = false; pl.classList.remove("drag"); dropCand(); token++; clearTimeout(resumeT);
    scareTxt.textContent = WORDS[word];
    scareEl.setAttribute("data-word", word);
    scareEl.classList.remove("out", "on"); void scareEl.offsetWidth; scareEl.classList.add("on");
    scareEl.setAttribute("aria-hidden", "false");
    unlock(); scream();
    // phones only buzz once the visitor has touched the page
    var ua = navigator.userActivation;
    if (navigator.vibrate && (!ua || ua.hasBeenActive)) { try { navigator.vibrate([90, 40, 260]); } catch (_) {} }
    clearTimeout(closeT); closeT = setTimeout(unscare, 2700);
  }
  function unscare() {
    if (!scaring) return;
    clearTimeout(closeT);
    scareEl.classList.add("out");
    setTimeout(function () {
      scareEl.classList.remove("on", "out"); scareEl.setAttribute("aria-hidden", "true");
      scaring = false; sayClear();
      resumeT = setTimeout(function () { if (state === "soon" && !dragging) loop(++token); }, 1500);
    }, 450);
  }
  scareEl.addEventListener("click", function () { if (Date.now() - scareAt > 900) unscare(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && scaring) unscare(); });

  /* ================= states ================= */
  function setState(st, animated) {
    var tok = ++token;
    dragging = false; pl.classList.remove("drag"); dropCand(); typed = "";
    Array.prototype.forEach.call(board.querySelectorAll(".lit"), function (e) { e.classList.remove("lit"); });
    if (st === "soon") { jump("REST"); sayClear(); loop(tok); return; }
    if (st === "live") {
      (async function () {
        if (animated && !RM) { if (!(await spell(tok, "IT'S OPEN", true))) return; }
        else says.textContent = "IT'S OPEN";
        if (tok !== token) return;
        await go("YES", !animated); light("YES", true);
      })();
      return;
    }
    if (animated && !RM) go("BYE"); else jump("BYE");
    light("BYE", true); says.textContent = "GOOD BYE";
  }

  var cds = document.querySelectorAll("[data-cd]"), last = {};
  function frame() {
    var t = now(), st = t < OPEN ? "soon" : t < CLOSE ? "live" : "closed";
    if (st !== state) { var prev = state; state = st; root.setAttribute("data-state", st); setState(st, prev !== null); }
    var p = parts((st === "soon" ? OPEN : CLOSE) - t);
    if (p.s === last.s && p.m === last.m && p.h === last.h && p.d === last.d) return;
    last = p;
    for (var k = 0; k < cds.length; k++) cds[k].textContent = pad(p[cds[k].getAttribute("data-cd")]);
  }

  Array.prototype.forEach.call(document.querySelectorAll("[data-join]"), function (b) {
    b.addEventListener("click", function () {
      var j = document.querySelector(".join"); if (!j) return;
      j.scrollIntoView({ behavior: RM ? "auto" : "smooth", block: "start" });
      var inp = j.querySelector('input[name="name"]'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, RM ? 0 : 650);
    });
  });

  /* review bar (preview only): run the clock from now, 4 s before noon, or after close; fire a scare */
  Array.prototype.forEach.call(document.querySelectorAll("[data-pv]"), function (b) {
    b.addEventListener("click", function () {
      var v = b.getAttribute("data-pv");
      if (v === "scare") { unlock(); var ks = Object.keys(WORDS); scare(ks[Math.floor(Math.random() * ks.length)]); return; }
      offset = v === "open" ? OPEN - 4000 - Date.now() : v === "after" ? CLOSE + 60000 - Date.now() : baseOffset;
      Array.prototype.forEach.call(document.querySelectorAll('[data-pv]:not([data-pv="scare"])'), function (x) { x.classList.toggle("on", x === b); });
      if (v === "open") window.scrollTo(0, 0);
      frame();
    });
  });

  /* ================= sign-up ================= */
  Array.prototype.forEach.call(document.querySelectorAll("form.f"), function (form) {
    var note = form.querySelector(".note"), done = form.parentNode.querySelector(".done");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var name = form.elements.name, email = form.elements.email;
      var okName = !!name.value.trim(), okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
      name.setAttribute("aria-invalid", okName ? "false" : "true");
      email.setAttribute("aria-invalid", okEmail ? "false" : "true");
      if (!okName || !okEmail) { note.textContent = "Name and email, please."; (okName ? email : name).focus(); return; }
      if (window.HW2_PREVIEW) { form.hidden = true; done.hidden = false; done.textContent = "Preview only. On the live page this puts you on the list."; return; }
      var body = {
        name: name.value.trim(), email: email.value.trim(), phone: form.elements.phone.value.trim(),
        consent: form.elements.consent.checked, company: form.elements.company.value, source: "drop-page"
      };
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true; note.textContent = "Signing you up...";
      function fail() { note.textContent = "Something went wrong. Try again."; btn.disabled = false; }
      fetch("https://cult-racing.pages.dev/api/join", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) { form.hidden = true; done.hidden = false; } else fail(); })
        .catch(fail);
    });
  });

  frame();
  setInterval(frame, 250);
})();
